"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateEventEditorContainer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const core_2 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const StateEventEditor_1 = __importStar(require("./StateEventEditor"));
const StyledContainer = styled_components_1.default.div `
  width: 100%;
`;
const StateEventEditorContainer = props => {
    const { shape, editorProps, onChange } = props;
    const { events = [] } = shape.data || {};
    const dragChangeRef = (0, react_1.useRef)({ sourceIndex: -1, targetIndex: -1 });
    const [dragId, setDragId] = (0, react_1.useState)();
    const [expanded, setExpanded] = (0, react_1.useState)();
    const sort = (0, core_ui_1.useSort)(events, item => item.id);
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor));
    const dragEvent = events.find(event => event.id === dragId);
    const clearDragChange = () => {
        dragChangeRef.current.sourceIndex = -1;
        dragChangeRef.current.targetIndex = -1;
    };
    const moveItem = (sourceIndex, destinationIndex) => {
        const updatedItems = (0, sortable_1.arrayMove)(events, sourceIndex, destinationIndex);
        if (shape.data) {
            shape.data.events = updatedItems;
            editorProps.updateShape();
            editorProps.updateWorkflow();
        }
    };
    // reset expanded when shape is updated
    (0, react_1.useEffect)(() => setExpanded(undefined), [shape]);
    return (react_1.default.createElement(core_ui_1.ConfigCard, null,
        react_1.default.createElement(core_ui_1.ConfigHeader, { end: react_1.default.createElement(core_2.IconButton, { size: 'small', onClick: () => {
                    const stateNode = shape.data;
                    if (stateNode) {
                        stateNode.addEvent({
                            transitions: [{ target: stateNode.path }]
                        });
                    }
                    onChange === null || onChange === void 0 ? void 0 : onChange();
                } },
                react_1.default.createElement(icons_1.AddCircleOutline, null)) }, "Transition"),
        react_1.default.createElement(core_1.DndContext, { sensors: sensors, onDragStart: event => {
                // prevent dragging if currently dragging an event
                if (dragEvent) {
                    return;
                }
                const index = events.findIndex(ev => ev.id === event.active.id);
                const ev = events[index];
                dragChangeRef.current.sourceIndex = index;
                setDragId(ev === null || ev === void 0 ? void 0 : ev.id);
            }, onDragOver: event => {
                const { active, over } = event;
                if (over && active.id !== over.id) {
                    dragChangeRef.current.targetIndex = sort.findIndex(over.id);
                    sort.reorder(active.id, over.id);
                }
            }, onDragEnd: () => {
                // only move if dragEvent exists
                const { sourceIndex, targetIndex } = dragChangeRef.current;
                if (dragEvent &&
                    sourceIndex > -1 &&
                    targetIndex > -1 &&
                    sourceIndex !== targetIndex) {
                    moveItem(sourceIndex, targetIndex);
                }
                clearDragChange();
                setDragId(undefined);
            }, onDragCancel: () => {
                clearDragChange();
                setDragId(undefined);
            } },
            react_1.default.createElement(sortable_1.SortableContext, { items: sort.items.map(event => event.id) },
                react_1.default.createElement(StyledContainer, null, sort.items.map(event => (react_1.default.createElement(StateEventEditor_1.SortableStateEventEditor, Object.assign({}, editorProps, { key: event.id, shape: shape, event: event, expanded: event.id === expanded, setExpanded: expanded => {
                        setExpanded(expanded ? event.id : undefined);
                    } })))))),
            react_1.default.createElement(core_1.DragOverlay, null, dragEvent && (react_1.default.createElement(StateEventEditor_1.default, Object.assign({}, editorProps, { isDragging: true, shape: shape, event: dragEvent, expanded: dragEvent.id === expanded })))))));
};
exports.StateEventEditorContainer = StateEventEditorContainer;
exports.default = exports.StateEventEditorContainer;
//# sourceMappingURL=StateEventEditorContainer.js.map